import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownDealer, ICadastroDealer, ICadastroGestor, IListas } from '../IFiltrosDealer';
import { BuscaCep } from '././../../../../shared/cep/busca-cep';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { ServiceAppService } from '../../../../security/service-app.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-dealer-cadastro',
  templateUrl: './dealer-cadastro.component.html',
  styleUrls: ['./dealer-cadastro.component.scss']
})
export class DealerCadastroComponent implements OnInit {
  @Input() cadastro: ICadastroDealer;
  @Input() cadastroGestor: ICadastroGestor;
  @Input() exibeCadastro: boolean = true;
  @Input() cadastroTitulo: string;
  @Input() listas: IListas;
  @Input() view: boolean;
  @Output() fecharModalCadastro: EventEmitter<boolean> = new EventEmitter<boolean>();
  submitted: boolean;
  camposVazios: string[] = [];
  erroCEP: boolean;
  statusDealer: DropdownDealer[];

  constructor(private buscaCep: BuscaCep,
    private filtroService: FiltroService,
    private service: ServiceAppService,
    private messageService: MessageService) {

    this.statusDealer = [
      { name: 'Ativo', code: 'S' },
      { name: 'Inativo', code: 'N' }
    ];
  }

  ngOnInit() { }

  saveDados() {
    this.submitted = true;
    const message = this.cadastroTitulo === 'Cadastrar' ? 'Cadastro realizado com sucesso!' : 'Alteração realizada com sucesso!';
    const camposVazios = this.verificarCamposVazios(this.cadastro);

    if (this.cadastroTitulo === 'Cadastrar') {
      const body = { cadastro: this.cadastro, cadastroGestor: this.cadastroGestor };

      if (camposVazios.length === 0 && this.verificarGestores()) {
        this.service.postDadosTexto(`/dealer/incluirDealer`, body).subscribe({
          next: () => {
			this.exibeCadastro = false;
            this.messageService.add({
              key: 'previsao-venda',
              severity: 'success',
              summary: 'Sucesso',
              detail: message,
              life: 3000
            });
          },
          error: (error) => {
            this.messageService.add({
              key: 'previsao-venda',
              severity: 'error',
              summary: 'Erro ao Cadastrar',
              detail: error?.error?.text || error?.error || 'Erro ao cadastrar dealer.',
              life: 3000
            });
            this.exibeCadastro = true;
          }
        });
      } else {
        this.exibeCadastro = true;
      }

    } else if (this.cadastroTitulo === 'Editar') {
      this.cadastro.grupoEconomico = this.cadastro.grupoEconomico == null ? 0 : this.cadastro.grupoEconomico
      this.cadastro.tipoDealer = this.cadastro.tipoDealer == null ? 0 : this.cadastro.tipoDealer
      const body = { cadastro: this.cadastro, cadastroGestor: this.cadastroGestor };

      if (this.verificarGestores()) {
        this.service.putDadosTexto(`/dealer/atualizarDealer`, body).subscribe({
          next: () => {
			this.exibeCadastro = false;
            this.messageService.add({
              key: 'previsao-venda',
              severity: 'success',
              summary: 'Sucesso',
              detail: message,
              life: 3000
            });
          },
          error: (error) => {
            this.messageService.add({
              key: 'previsao-venda',
              severity: 'error',
              summary: 'Erro ao Editar',
              detail: error?.error?.text || error?.error || 'Erro ao editar dealer.',
              life: 3000
            });
            this.exibeCadastro = true;
          }
        });
      } else {
        this.exibeCadastro = true;
      }
    }
  }

  verificarCamposVazios(dealer: ICadastroDealer): string[] {
    const camposVazios: string[] = [];
    const camposObrigatorios: (keyof ICadastroDealer)[] = [
      'codigo', 'nomeDealer', 'cnpj', 'status', 'cep', 'pais',
      'regiao', 'uf', 'cidade', 'logradouro', 'bairro', 'nomeContato',
      'ddd', 'telefone', 'email'
    ];

    camposObrigatorios.forEach(key => {
      if (dealer[key] === "" || dealer[key] === null || dealer[key] === undefined) {
        camposVazios.push(key);
      }
    });

    return camposVazios;
  }

  hideDialog() {
    this.submitted = false;
    this.exibeCadastro = false;
    this.fecharModalCadastro.emit(this.exibeCadastro);
    this.cadastro = {
      codigo: '', nomeDealer: '', cnpj: '', status: '',
      incricaoMunicipal: '', incricaoEstadual: '', cep: '',
      pais: 0, regiao: 0, uf: 0, cidade: 0, logradouro: '', bairro: '',
      complemento: '', nomeContato: '', ddd: 0, telefone: 0, email: ''
    };

    this.cadastroGestor = {
      nomeGestorVeiculo: '', cpfGestorVeiculo: '', idGestorVeiculo: 0,
      nomeGestorPeca: '', cpfGestorPeca: '', idGestorPeca: 0,
      nomeGestorPosVenda: '', cpfGestorPosVenda: '', idGestorPosVenda: 0
    }
  }

  private carregarDDLUf(idUf) {
    this.filtroService.buscar('estado/'.concat(this.cadastro.regiao.toString()))
      .then(r => { this.listas.itensUf = r.filtros; });

    if (idUf) {
      this.cadastro.uf = idUf;
      this.carregarDDLCidade(0);
    }
  }

  private carregarDDLCidade(idCidade) {
    this.filtroService.buscar('cidade/'.concat(this.cadastro.uf.toString()))
      .then(r => { this.listas.itensCidade = r.filtros; });

    if (idCidade) {
      this.cadastro.cidade = idCidade;
    }
  }

  buscarCEP() {
    this.buscaCep.get(this.cadastro.cep).then(response => {
      this.erroCEP = false
      let element = response;
      this.cadastro.pais = Number(element.idPais);
      this.cadastro.regiao = Number(element.idRegiao);
      this.cadastro.cidade = Number(element.idCidade);
      this.cadastro.logradouro = element.logradouro;
      this.cadastro.bairro = element.bairro;
      this.cadastro.complemento = element.complemento;
      this.carregarDDLUf(Number(element.idUf));

    }).catch((_error) => {
      this.erroCEP = true
    });
  }

  edit() {
    this.view = false;
    this.cadastroTitulo = 'Editar';
  }

  verificarGestores(): boolean {
    if ((this.cadastroGestor.cpfGestorVeiculo && !this.cadastroGestor.nomeGestorVeiculo) ||
      this.cadastroGestor.nomeGestorVeiculo && !this.cadastroGestor.cpfGestorVeiculo) {
      return false
    }
    if ((this.cadastroGestor.cpfGestorPeca && !this.cadastroGestor.nomeGestorPeca) ||
      this.cadastroGestor.nomeGestorPeca && !this.cadastroGestor.cpfGestorPeca) {
      return false
    }
    if ((this.cadastroGestor.cpfGestorPosVenda && !this.cadastroGestor.nomeGestorPosVenda) ||
      this.cadastroGestor.nomeGestorPosVenda && !this.cadastroGestor.cpfGestorPosVenda) {
      return false
    }
    return true
  }
}